module.exports = __webpack_public_path__ + "img/029687c7478ce38af59f4d463344d0a9.png";